import { useMsal } from '@azure/msal-react';
import { FC, PropsWithChildren, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

import { findUser } from '@src/main/modules/common/user/application/find/findUser';
import { User } from '@src/main/modules/common/user/domain/User';
import { createUserHttpRepository } from '@src/main/modules/common/user/infrastructure/UserHttpRepository';
import { MsalTokenProvider } from '@src/main/ui/msalConfig';

const ProtectedRoute: FC<PropsWithChildren> = ({ children }) => {
  const [user, setUser] = useState<User>();
  const { instance, accounts } = useMsal();

  useEffect(() => {
    async function fetchUser() {
      const newUser = createUserHttpRepository(new MsalTokenProvider(instance, accounts));
      const res = await findUser(newUser);
      setUser(res);
    }

    fetchUser();
  }, [instance, accounts]);

  return user && <>{user.roles.includes('ADMIN') ? children : <Navigate to="/" />}</>;
};

export default ProtectedRoute;
